/**
 * Orders the filters based on a predefined order.
 * @param filters - The filters to be ordered.
 * @param order - The order in which the filters should be sorted.
 * @returns The ordered filters.
 */ function orderStoreFilters(filters, order) {
    const orderMap = new Map(order.map((name, index)=>[
            name,
            index
        ]
    ));
    return filters.slice().sort((a, b)=>{
        var ref;
        const indexA = (ref = orderMap.get(a.name)) !== null && ref !== void 0 ? ref : Infinity;
        var ref1;
        const indexB = (ref1 = orderMap.get(b.name)) !== null && ref1 !== void 0 ? ref1 : Infinity;
        return indexA - indexB;
    });
}

export { orderStoreFilters };
//# sourceMappingURL=order-store-filters.js.map
